export default function getInstallationCountry() {
  return window?.$dt?.objConfig?.Country || '';
}
